module.exports = __webpack_public_path__ + "static/media/planner-power-icon.6b7c9632.svg";